<template>
    <div>
        <!-- 分组管理弹窗 -->
        <el-dialog title="店铺分组管理" :visible="visible" width="640px" custom-class="shop-group-manage-dialog"
            @close="handleClose">
            <div class="group_manage_toolbar">
                <el-button size="small" type="primary" @click="handleAddShopGroup">新增分组</el-button>
            </div>
            <div class="group_manage_body">
                <el-table :data="groupList" size="small" border v-loading="groupLoading" :max-height="360">
                    <el-table-column prop="name" label="分组名称" min-width="180"></el-table-column>
                    <el-table-column prop="shop_count" label="店铺数" width="90" align="center"></el-table-column>
                    <el-table-column prop="sort" label="排序" width="90" align="center"></el-table-column>
                    <el-table-column label="操作" width="150" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="handleEditShopGroup(scope.row)">编辑</el-button>
                            <el-button type="text" size="small" @click="handleDeleteShopGroup(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-empty v-if="groupList.length === 0 && !groupLoading" description="暂无分组" :image-size="90"></el-empty>
            </div>
        </el-dialog>

        <!-- 新增/编辑分组弹窗 -->
        <el-dialog :title="groupFormEdit ? '编辑分组' : '新增分组'" :visible.sync="groupFormVisible" width="400px">
            <el-form :model="groupForm" label-width="80px">
                <el-form-item label="分组名称">
                    <el-input v-model="groupForm.name" maxlength="50" show-word-limit placeholder="请输入分组名称"></el-input>
                </el-form-item>
                <el-form-item label="排序值">
                    <el-input-number v-model="groupForm.sort" :min="0" :max="9999"
                        style="width:100%;"></el-input-number>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="groupFormVisible = false">取消</el-button>
                <el-button size="small" type="primary" :loading="groupFormLoading"
                    @click="submitShopGroupForm">确定</el-button>
            </span>
        </el-dialog>

        <el-dialog title="设置店铺分组" :visible="batchGroupVisible" width="420px">
            <el-form label-width="90px">
                <el-form-item label="已选店铺">
                    <div class="batch_group_tip">{{ shopIds.length }} 个</div>
                </el-form-item>
                <el-form-item label="选择分组">
                    <el-select v-model="batchGroupId" placeholder="请选择分组" clearable style="width:100%;">
                        <el-option label="移出分组" :value="0"></el-option>
                        <el-option v-for="item in groupList" :key="item.id" :label="item.name"
                            :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="cancelSetGroup">取消</el-button>
                <el-button size="small" type="primary" :loading="batchGroupLoading"
                    @click="submitShopBatchSetGroup">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
    name: 'ShopGroupManage',
    props: {
        // 控制组件显示/隐藏
        visible: {
            type: Boolean,
            default: false
        },
        // 控制组件显示/隐藏
        batchGroupVisible: {
            type: Boolean,
            default: false
        },
        // 控制组件显示/隐藏
        batchShopIds: {
            type: Array,
            default: () => []
        },
        // 分组列表（支持外部传入初始化）
        initGroupList: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            groupList: [],
            shopIds: [],
            groupLoading: false,
            groupLoading: false,
            groupFormVisible: false,
            groupFormEdit: false,
            groupFormLoading: false,
            groupForm: { id: null, name: '', sort: 0 },
            batchGroupLoading: false,
            batchGroupId: '',//分组ID
        }
    },
    watch: {
        // 监听外部传入的可见状态，同步分组列表
        visible(newVal) {
            if (newVal) {
                this.groupList = [...this.initGroupList];
                this.shopIds = [...this.batchShopIds];
            }
        },
        initGroupList(newVal) {
            if (newVal) {
                this.groupList = [...this.initGroupList];
            }
        },
        batchShopIds(newVal) {
            if (newVal) {
                this.shopIds = [...this.batchShopIds];
            }
        }
    },
    methods: {
        ...mapActions({
            opShopBoardGroupCreate: "shop_board/opShopBoardGroupCreate",
            opShopBoardGroupUpdate: "shop_board/opShopBoardGroupUpdate",
            opShopBoardGroupDelete: "shop_board/opShopBoardGroupDelete",
            opShopBoardBatchSetGroup: "shop_board/opShopBoardBatchSetGroup",
        }),
        // 关闭弹窗时通知父组件
        handleClose() {
            this.$emit('update:visible', false);
        },
        // 新增分组
        handleAddShopGroup() {
            this.groupForm = { id: null, name: '', sort: 0 };
            this.groupFormEdit = false;
            this.groupFormVisible = true;
        },
        // 编辑分组
        handleEditShopGroup(row) {
            this.groupForm = { ...row };
            this.groupFormEdit = true;
            this.groupFormVisible = true;
        },
        // 删除分组（需调用接口的话补充逻辑）
        handleDeleteShopGroup(row) {
            this.$confirm('确定要删除该分组吗？', '提示', {
                type: 'warning'
            }).then(async () => {
                this.opShopBoardGroupDelete({
                    id: row.id,
                    success: (res) => {
                        if (res.code === 200) {
                            this.$message.success('删除成功');
                            this.$emit('groupChange'); // 通知父组件分组变化
                        } else {
                            this.$message.error(res.message || '删除失败');
                        }
                    }
                });

                // }
            }).catch(() => {
                this.$message.error(res.message || '删除异常');
            });
        },
        // 提交新增/编辑分组（需调用接口的话补充逻辑）
        submitShopGroupForm() {
            if (!this.groupForm.name) {
                return this.$message.warning('请输入分组名称');
            }
            this.groupFormLoading = true;
            const data = { name: this.groupForm.name.trim(), sort: this.groupForm.sort || 0 };
            try {
                const callback = (res, successMessage) => {
                    this.groupFormLoading = false;
                    if (res.code === 200) {
                        this.$message.success(successMessage);
                        this.groupFormVisible = false;
                    } else {
                        this.$message.error(res.message || '操作失败');
                    }
                    this.$emit('groupChange'); // 通知父组件分组变化
                };
                if (!this.groupFormEdit) {
                    this.opShopBoardGroupCreate({
                        data,
                        success: (res) => callback(res, '新增成功')
                    });
                } else {
                    this.opShopBoardGroupUpdate({
                        id: this.groupForm.id,
                        data,
                        success: (res) => callback(res, '修改成功')
                    });
                }

                // }
            } catch (error) {
                this.$message.error('操作失败');
            } finally {
                this.groupFormLoading = false;
            }
        },
        // 主动拉取分组列表（如需独立获取可补充接口逻辑）
        getShopGroupList() {
            this.groupLoading = true;
            try {
                // const res = await getShopGroupList();
                // if (res.code === 0) {
                //   this.groupList = res.data;
                //   this.$emit('groupChange', this.groupList);
                // }
            } catch (error) {
                this.$message.error('获取分组列表失败');
            } finally {
                this.groupLoading = false;
            }
        },
        submitShopBatchSetGroup() {
            if (this.batchGroupId === '' || this.batchGroupId === null) {
                this.$message.warning('请选择分组');
                return;
            }
            if (this.shopIds.length === 0) {
                this.$message.warning('未找到可设置的店铺');
                return;
            }
            this.batchGroupLoading = true;
            const isRemoveGroup = this.batchGroupId === 0;
            this.opShopBoardBatchSetGroup({
                data: {
                    mer_shop_ids: this.shopIds,
                    group_id: isRemoveGroup ? null : this.batchGroupId,
                },
                success: (res) => {
                    this.batchGroupLoading = false;
                    if (res.code === 200) {
                        this.$message.success(isRemoveGroup ? '已移出分组' : '设置成功');
                        this.$emit('update:batchGroupVisible', false)
                        this.$emit('update:batchShopIds', [])

                        this.$emit('groupChange'); // 通知父组件分组变化
                    } else {
                        this.$message.error(res.message || '设置失败');
                    }
                }
            });
        },
        cancelSetGroup() {
            this.$emit('update:batchGroupVisible', false)
        }
    }
}
</script>

<style scoped>
.group_manage_toolbar {
    margin-bottom: 15px;
}

.group_manage_body {
    padding: 0 5px;
}
</style>